<template lang="pug">
  el-header(style="height: 40px;")
    img(:src="header_logo")
</template>

<script>
import HeaderLogo from '../assets/image/logotypo.png'
export default {
  name: 'Header',
  data () {
    return {
      header_logo: HeaderLogo
    }
  }
}
</script>

<style lang="scss">
  .el-header {
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (min-width: 768px) {
        height: 60px !important;
    }
    @media screen and (min-width: 1200px) {
        height: 80px !important;
    }
    > img {
      height: 16px;
      width: auto;
      @media screen and (min-width: 768px) {
        height: 24px;
      }
      @media screen and (min-width: 1200px) {
        height: 32px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue